import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar, Nav, Container, Card, Button } from 'react-bootstrap';
import logo from '../assets/images/devadigax.png';

const MyNavbar = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg" fixed="top" className="d-none d-sm-block">
        <Container>
          <Navbar.Brand as={Link} to="/"><img src={logo} alt="Logo" height="50px" className="logo" /><b> Devadiga World</b></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              <Nav.Link as={Link} to="/">Home</Nav.Link>
              <Nav.Link as={Link} to="/explore">Explore</Nav.Link>
              <Nav.Link as={Link} to="/blog">Blog</Nav.Link>
              <Nav.Link as={Link} to="/contact">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Button variant="dark" href="https://www.instagram.com/devadiga.world/" target="_blank">
              <h4><i className="bi bi-instagram"></i></h4>
            </Button>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Container className='nav-bar-container'>
        <Card body className='radius-15 text-light bg-black mb-4 d-block d-sm-none'>
          <Nav className="w-100 justify-content-between">
            <Navbar.Brand as={Link} to="/"><img src={logo} alt="Logo" height="50px" className="logo" /></Navbar.Brand>
            <Nav.Link as={Link} to="/explore" className='nav-link text-light'>Explore</Nav.Link>
            <Nav.Link as={Link} to="/blog" className='nav-link text-light'>Blog</Nav.Link>
            <Nav.Link as={Link} to="/contact" className='nav-link text-light'>Contact</Nav.Link>
          </Nav>
        </Card>
      </Container>
    </>
  );
};

export default MyNavbar;